import { motion } from "motion/react";
import SpinningLogo from "#components/design/SpinningLogo.tsx";
import logo from "./logo.svg";

export default function LanderLogo({
	className,
}: {
	readonly className?: string;
}) {
	return (
		<motion.div
			className={`flex flex-row items-center justify-center gap-1 animate-fade-in ${className}`}
			initial={{
				opacity: 0,
				scale: 0.5,
			}}
			animate={{
				opacity: 1,
				scale: 1,
			}}
			transition={{
				type: "spring",
				duration: 3,
			}}
		>
			<SpinningLogo className="h-24 w-24 md:h-37.5 md:w-37.5 -mr-8" />
			<img src={logo} alt="Stringiverse Logo" className="h-18 md:h-48" />
		</motion.div>
	);
}
